import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageComponent } from './image.component';
import { ImageDimensionPipe } from '@app/pipes/image-dimension.pipe';
import { LcpDsDetectorService } from '@design-system/components/molecules/image/services/lcp-detector.service';

@NgModule({
  declarations: [
    ImageComponent
  ],
  exports: [
    ImageComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [
    ImageDimensionPipe,
    LcpDsDetectorService
  ]
})
export class ImageModule { }
